var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M14.5 8a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0M8 8a4 4 0 1 1 8 0 4 4 0 0 1-8 0M6.54 18.5h10.92a4.07 4.07 0 0 0-4.032-3.5h-2.856a4.07 4.07 0 0 0-4.031 3.5M5 19.072a5.57 5.57 0 0 1 5.572-5.572h2.856A5.57 5.57 0 0 1 19 19.072a.93.93 0 0 1-.928.928H5.928A.93.93 0 0 1 5 19.072"
  })));
};
export default SvgUser;